import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BL } from 'src/environments/environment';
import { ConfigService } from '../config/config.service';
import { FlightResponse } from 'src/app/flight/models/FlightResponse';
import { NewTicketRequest } from 'src/app/flight/models/NewTicketRequest';
import { NewTicketResponse } from 'src/app/flight/models/NewTicketResponse';
import { AuthorizationService } from '../authorization/authorization.service';
import { PasseLivreService } from './passe-livre.service';

@Injectable({
  providedIn: 'root'
})
export class PasseLivreExternalCrewService extends PasseLivreService {

  constructor(protected http: HttpClient, 
              protected configService: ConfigService,
              protected authorizationService: AuthorizationService) {
    super(http, configService);    
  }

  getFlightsWithConex(dateFlight: string, dateTimeClient: string, origin: string, destination: string): Observable<FlightResponse[]> {
    const params = new String().concat(`dateFlight=${dateFlight}`)
      .concat(`&dateTimeClient=${dateTimeClient}`)
      .concat(`&origin=${origin}`)
      .concat(`&destination=${destination}`)
      .concat(`&anacCode=${this.authorizationService.getCrewCode()}`);

    return this.http.get<FlightResponse[]>(`${this.API_URL}${BL.getFlights}?${params}`);
  }

  newTicket(newTicketRequest: NewTicketRequest): Observable<NewTicketResponse> {
    return this.http.post<NewTicketResponse>(`${this.API_URL}${BL.newTicketExternalCrew}`, newTicketRequest);
  }
}
